<!--
  @author:chen.hao
  @time:2018/11/6
  @disc:供应商管理
 -->

<template>
  <div class="supplier-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="70px">
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="userName"
        label="用户名"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="registerMobile"
        label="注册手机"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="legalPerson"
        label="法人代表"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="applyTime"
        label="申请时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        show-overflow-tooltip
        :formatter="formatStatus">
      </el-table-column>
      <el-table-column
        label="操作"
        width="250px">
        <template slot-scope="scope">
          <el-button @click="infoView(scope.row)" v-permission="'0090202'">查看</el-button>
          <el-button @click="review(scope.row)" v-if="scope.row.status===0" v-permission="'0090201'">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <review-dialog :show.sync="reviewDialogShow" :info="reviewDialogInfo"></review-dialog>
    <info-view-dialog :show.sync="infoViewDialogShow" :info="infoViewDialogInfo"></info-view-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ReviewDialog from './reviewDialog'
import InfoViewDialog from './infoViewDialog'
export default {
  name: 'supplierManager',
  components: { InfoViewDialog, ReviewDialog },
  data () {
    return {
      statusArr: [
        { value: '', label: '全部' },
        { value: 0, label: '待审核' },
        { value: 2, label: '已审核' },
        { value: 1, label: '未通过' }
      ],
      form: {
        status: '',
        userName: '',
        companyName: '',
        mobile: ''
      },
      reviewDialogShow: false,
      reviewDialogInfo: '',
      infoViewDialogShow: false,
      infoViewDialogInfo: ''
    }
  },
  computed: {
    ...mapGetters({ list: 'getSupplierList', listState: 'getSupplierListState' })
  },
  methods: {
    ...mapActions([
      'getSupplierList',
      'getSupplierInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getSupplierList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getSupplierList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getSupplierList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 格式化状态
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    },
    // 查看
    infoView (row) {
      this.getSupplierInfo({ accountId: row.accountId })
        .then(res => {
          this.infoViewDialogInfo = res
          this.infoViewDialogShow = true
        })
    },
    // 审核
    review (row) {
      this.getSupplierInfo({ accountId: row.accountId })
        .then(res => {
          this.reviewDialogInfo = res
          this.reviewDialogShow = true
        })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
